import Vue from "vue";
import App from "./App";
import router from "./router/index";
import {Pagination} from 'vue-pagination-2';

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";

// Vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);
Vue.component('pagination', Pagination);
const opts = {}

export default new Vuetify(opts)

// Vuetify
Vue.use(VueAxios, axios);
Vue.use(Vuetify);

// Import Axios
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(PaperDashboard);

/* eslint-disable no-new */
new Vue({
  router,
  axios,
  Vuetify,
  Pagination,
  VueAxios,
  render: (h) => h(App),
}).$mount("#app");
